import * as yup from 'yup';

export const groupModify = yup.object().shape({
  name: yup.string().required().min(1).label("Can't be empty"),
  metrics_ids: yup.array().of(yup.number()),
});
